  import React, { useEffect, useState, useRef, useCallback } from "react";
  import { useSwipeable } from 'react-swipeable';
  import axios from "./axios";
  import "./styles/dashboard.css";
  import "./styles/vendor.css";
  import { useNavigate, useLocation } from "react-router-dom";
  import { Line } from "react-chartjs-2";
  import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
  } from "chart.js";
  import { toast, ToastContainer } from "react-toastify";
  import "react-toastify/dist/ReactToastify.css";
  import { Link } from "react-router-dom";
  import { QRCodeCanvas } from "qrcode.react";
  import Modal from "./components/Modal";
  import Papa from "papaparse";
  import JSZip from "jszip"; 
  import { saveAs } from "file-saver";
  import AddressAutocomplete from "./components/AddressAutocomplete";
  import StoreAutocomplete from "./components/StoreAutocomplete";
  import RefreshFcmButton from "./components/RefreshFcmButton";
  import ProductTable from "./components/ProductTable";
  import EnableNotificationsModal from "./components/EnableNotificationsModal";
  import ReportBugButton from "./components/ReportBugButton";
  import NotificationWarning from "./components/NotificationWarning";
  import BarcodeProductManager from "./components/BarcodeProductManager";
  import VendorLinkedProducts from "./components/VendorLinkedProducts";
  import UnifiedProductTable from "./components/UnifiedProductTable";
  import HelpModal from "./components/HelpModal";
  import UXHint from "./components/UXHint";
  import QRCode from "qrcode";
  import { io } from "socket.io-client";

  ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

  const API_URL = "/scans";
  const PRODUCT_API = "/products";

// Socket singleton module-level — créé une seule fois, partagé entre renders
const socket = io(process.env.REACT_APP_API_BASE_URL || window.location.origin, {
  autoConnect: false,
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  randomizationFactor: 0.5,
});

const getCityFromCoords = async (lat, lng) => {
  try {
    const res = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&zoom=10&addressdetails=1`,
      {
        headers: { "User-Agent": "crushme-app/1.0" }
      }
    );
    const data = await res.json();
    return data.address.city || data.address.town || data.address.village || "";
  } catch (err) {
    console.error("Erreur reverse geocoding :", err);
    return "";
  }
};

  const Dashboard = () => {
    // Barcode pré-rempli passé via ?barcode=XXX (retour depuis le flow "produit inconnu")
    const location = useLocation();
    const barcodeFromUrl = new URLSearchParams(location.search).get("barcode") || "";

    const [stats, setStats] = useState({ totalScans: 0, scansToday: 0 });
    const [communityInterest, setCommunityInterest] = useState({ total: 0, details: [] });
    const [customStatus] = useState("en stock");
    const [productId, setProductId] = useState("");
    const [productName, setProductName] = useState("");
    const [chartData, setChartData] = useState(null);
    const [productStats, setProductStats] = useState(null);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [newProduct, setNewProduct] = useState({ productId: "", articleName: "", description: "", status: "en stock" });
    const [lastScanned, setLastScanned] = useState(null);
    const [vendorLocation, setVendorLocation] = useState(null);
    const [vendorAddress, setVendorAddress] = useState("");
    const [vendorCity, setVendorCity] = useState("");
    const [isSavingLocation, setIsSavingLocation] = useState(false);
    const [showNotifModal, setShowNotifModal] = useState(false);
    // Incrémenter pour forcer VendorLinkedProducts à recharger ses données
    const [linkedProductsKey, setLinkedProductsKey] = useState(0);
    const [statsKey, setStatsKey] = useState(0);
    const [activeTab, setActiveTab] = useState("overview");
    const [totalProducts, setTotalProducts] = useState(0);
    const [showHelp, setShowHelp] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deletePassword, setDeletePassword] = useState("");
    const [deleteSeedPhrase, setDeleteSeedPhrase] = useState("");
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [editingName, setEditingName] = useState(false);
    const [editNameValue, setEditNameValue] = useState(() => {
      try { return JSON.parse(localStorage.getItem("user"))?.name || ""; } catch { return ""; }
    });

    // ── ONGLET "MON MAGASIN" — states ──────────────────────────────────
    const [store, setStore] = useState(null);
    const [storeLoading, setStoreLoading] = useState(false);
    const [storeForm, setStoreForm] = useState({ name: "", address: "", siret: "", lat: null, lng: null });
    const [validationCode, setValidationCode] = useState("");
    const [plainCode, setPlainCode] = useState(null);
    const [storeStats, setStoreStats] = useState(null);
    const [liveScans, setLiveScans] = useState([]);
    const [goalInput, setGoalInput] = useState(50);
    const [goalSaving, setGoalSaving] = useState(false);

    const handleSaveName = async () => {
      if (!editNameValue.trim() || editNameValue.trim() === user?.name) {
        setEditingName(false);
        return;
      }
      try {
        // axios instance already adds token via interceptor (user.token in localStorage)
        await axios.put("/auth/update-name", { name: editNameValue.trim() });
        const stored = JSON.parse(localStorage.getItem("user")) || {};
        stored.name = editNameValue.trim();
        localStorage.setItem("user", JSON.stringify(stored));
        setUser(stored);
        setEditingName(false);
        toast.success("✅ Nom mis à jour");
      } catch (err) {
        console.error("Erreur update-name :", err);
        toast.error("❌ Impossible de mettre à jour le nom");
      }
    };

    const deleteAccount = () => {
      setDeletePassword("");
      setDeleteSeedPhrase("");
      setShowDeleteModal(true);
    };

    const handleDeleteConfirm = async () => {
      const isPseudo = !user?.email;
      setDeleteLoading(true);
      try {
        const body = isPseudo
          ? { seed: deleteSeedPhrase.trim().split(/\s+/) }
          : { password: deletePassword };
        await axios.delete("/auth/delete-account", { data: body });
        localStorage.clear();
        window.location.href = "/";
      } catch {
        toast.error("❌ Confirmation incorrecte ou impossible de supprimer le compte.");
      } finally {
        setDeleteLoading(false);
      }
    };

    const scrollToTable = () => {
      const table = document.getElementById("product-table");
      if (table) {
        table.scrollIntoView({ behavior: "smooth" });
      }
    };

    const [user, setUser] = useState(() => {
      try {
        return JSON.parse(localStorage.getItem("user")) || {};
      } catch {
        return {};
      }
    });

    const [isSubscribedToPush, setIsSubscribedToPush] = useState(() => {
      try {
        const storedUser = JSON.parse(localStorage.getItem("user")) || {};
        // ✅ Valeur par défaut : false si aucune donnée
        return storedUser.subscribedToPush === true;
      } catch {
        return false;
      }
    });

    const saveVendorLocation = () => {
      if (!navigator.geolocation) {
        toast.error("🌐 Géolocalisation non supportée par ce navigateur.");
        return;
      }
      setIsSavingLocation(true);
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          try {
            const coords = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            };
            await axios.put("/auth/update-location", {
              userId: user?.id,
              location: coords
            });
            setVendorLocation(coords);
            toast.success("📍 Localisation enregistrée !");
          } catch (err) {
            console.error("Erreur enregistrement localisation vendeur:", err);
            toast.error("❌ Impossible d'enregistrer la localisation.");
          } finally {
            setIsSavingLocation(false);
          }
        },
        (error) => {
          console.error("Erreur géolocalisation:", error);
          toast.error("❌ Impossible de récupérer la position actuelle.");
          setIsSavingLocation(false);
        },
        { timeout: 10000 }
      );
    };

    // ── ONGLET "MON MAGASIN" — fonctions ───────────────────────────────
    const fetchStore = useCallback(async () => {
      try {
        const res = await axios.get("/stores/my");
        const s = res.data.store || null;
        setStore(s);
        if (s?.monthlyGoal) setGoalInput(s.monthlyGoal);
      } catch (err) {
        console.error("❌ Erreur fetchStore :", err);
      }
    }, []);

    const handleSaveGoal = async () => {
      const g = parseInt(goalInput, 10);
      if (!Number.isInteger(g) || g < 1 || g > 10000) return;
      setGoalSaving(true);
      try {
        const res = await axios.patch("/stores/my/goal", { goal: g });
        setStore(res.data.store);
        toast.success("✅ Objectif mis à jour");
      } catch {
        toast.error("❌ Impossible de mettre à jour l'objectif");
      } finally {
        setGoalSaving(false);
      }
    };

    const fetchStoreStats = useCallback(async () => {
      if (!user?.id) return;
      try {
        const res = await axios.get(`/dashboard/${user.id}`);
        setStoreStats(res.data);
      } catch (err) {
        console.error("❌ Erreur fetchStoreStats :", err);
      }
    }, [user?.id]);

    const fetchLiveScans = useCallback(async () => {
      if (!user?.id) return;
      try {
        const res = await axios.get(`/dashboard/${user.id}/live`);
        setLiveScans(res.data.scans || []);
      } catch (err) {
        console.error("❌ Erreur fetchLiveScans :", err);
      }
    }, [user?.id]);

    const handleRegisterStore = async () => {
      if (!storeForm.name || !storeForm.address || !storeForm.siret) {
        toast.error("Nom, adresse et SIRET sont requis.");
        return;
      }
      setStoreLoading(true);
      try {
        // Utiliser coords GPS depuis Google Places si disponibles, sinon géocoder via Nominatim
        let lat = storeForm.lat ?? null;
        let lng = storeForm.lng ?? null;
        if (lat === null || lng === null) {
          try {
            const controller = new AbortController();
            const geoTimeout = setTimeout(() => controller.abort(), 6000);
            const geoRes = await fetch(
              `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(storeForm.address)}&limit=1`,
              { headers: { "User-Agent": "CrushNow/2.0 (contact@crush-now.fr)" }, signal: controller.signal }
            );
            clearTimeout(geoTimeout);
            const geoData = await geoRes.json();
            if (geoData?.[0]) {
              lat = parseFloat(geoData[0].lat);
              lng = parseFloat(geoData[0].lon);
              console.log(`📍 [STORE] Géocodage réussi : lat=${lat} lng=${lng}`);
            }
          } catch (geoErr) {
            console.warn("⚠️ [STORE] Géocodage Nominatim échoué, enregistrement sans coords :", geoErr.message);
          }
        }

        const res = await axios.post("/stores/register", {
          name: storeForm.name,
          address: storeForm.address,
          siret: storeForm.siret,
          ...(lat !== null && lng !== null ? { lat, lng } : {})
        });
        setStore(res.data.store);
        if (res.data.validation_code_plain) setPlainCode(res.data.validation_code_plain);
        toast.success("📬 Code de validation envoyé par courrier");
      } catch (err) {
        console.error("❌ Erreur enregistrement magasin :", err);
        toast.error(err.response?.data?.message || "❌ Impossible d'enregistrer le magasin.");
      } finally {
        setStoreLoading(false);
      }
    };

    const handleValidateStore = async () => {
      if (!validationCode) {
        toast.error("Veuillez saisir le code reçu par courrier.");
        return;
      }
      setStoreLoading(true);
      try {
        await axios.post("/stores/validate", { store_id: store._id, code: validationCode });
        toast.success("✅ Magasin vérifié !");
        await fetchStore();
      } catch (err) {
        console.error("❌ Erreur validation magasin :", err);
        toast.error(err.response?.data?.message || "❌ Code incorrect ou expiré.");
      } finally {
        setStoreLoading(false);
      }
    };
    // ───────────────────────────────────────────────────────────────────

    const [generatedQR, setGeneratedQR] = useState(null);
    const [zipReady, setZipReady] = useState(null);
    const [scannedProducts, setScannedProducts] = useState([]);
    const [editingProductId, setEditingProductId] = useState(null);
    const [editedProduct, setEditedProduct] = useState({});
    useEffect(() => { window.scrollTo(0, 0); }, []);

    useEffect(() => {
      if (location.state?.tab) setActiveTab(location.state.tab);
    }, []);

    useEffect(() => {
      const storedUser = JSON.parse(localStorage.getItem("user"));
      const vendorId = storedUser?.id;

      const onConnect = () => {
        if (vendorId) {
          socket.emit("registerUser", vendorId);
          console.log(`🔧 [DASH registerUser] id=${vendorId} socketId=${socket.id}`);
        }
      };

      socket.on("connect", onConnect);
      socket.connect();

      return () => {
        socket.off("connect", onConnect);
        socket.disconnect();
      };
    }, []);

    const [selectedProductId, setSelectedProductId] = useState("");
    const [articleName, setArticleName] = useState("");
    
    useEffect(() => {
      const alreadyPrompted = localStorage.getItem("notifPromptShown");
      if (!alreadyPrompted && typeof Notification !== "undefined" && Notification.permission === "default") {
        setTimeout(() => setShowNotifModal(true), 3000);
      }
    }, []);

    useEffect(() => {
      const fetchPushStatus = async () => {
        try {
          const res = await axios.get(`/auth/${user?.id}`);
          if (res.data?.subscribedToPush !== undefined) {
            setIsSubscribedToPush(!!res.data.subscribedToPush);
            console.log("🔄 Statut push récupéré :", res.data.subscribedToPush);
          }
        } catch (err) {
          console.error("❌ Erreur récupération statut push :", err);
        }
      };
      if (user?.id) fetchPushStatus();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user?.id]);

    useEffect(() => {
      const fetchScanned = async () => {
        try {
          const res = await axios.get("/products");
          setScannedProducts(res.data);
        } catch (err) {
          console.error("❌ Erreur récupération produits scannés :", err);
        }
      };

      fetchScanned();

      socket.on("productUpdated", (updatedProduct) => {
        console.log("Produit mis à jour reçu:", updatedProduct);
        setScannedProducts((prev) =>
          prev.map((p) => (p._id === updatedProduct._id ? updatedProduct : p))
        );
        toast.info(`🔄 Produit mis à jour : ${updatedProduct.articleName}`);
      });

      return () => {
          socket.off("productUpdated");
        };
      }, []);

    // ✅ Filtrer les scans par date
    const fetchFilteredScans = async () => {
      try {
        if (!startDate || !endDate) {
          toast.error("Veuillez sélectionner une date de début et de fin.");
          return;
        }
        const res = await axios.get(`${API_URL}/stats/filter/date`, {
          params: {
            start: startDate,
            end: endDate,
          },
        });

        const scansArray = Array.isArray(res.data) ? res.data : res.data.scans || [];

        setProductStats({
          search: `${startDate} → ${endDate}`,
          total: scansArray.length,
          scans: scansArray
        });
        scrollToTable();
        
        toast.dismiss();
        toast.success(`✅ ${scansArray.length} résultats trouvés.`, {
          closeOnClick: false
        });
      } catch (err) {
        console.error("❌ Erreur filtre par date :", err);
        toast.error("❌ Erreur lors de l'application des filtres.");
      }
    };

    // ✅ Temps réel : nouveau produit créé
    useEffect(() => {

      // 🆕 Nouveau produit créé
      socket.on("productCreatedVendor", (newProduct) => {
        console.log("🆕 Nouveau produit reçu (vendeur) :", newProduct);
        setScannedProducts((prev) => {
          if (prev.some((p) => p._id === newProduct._id)) return prev;
          return [newProduct, ...prev];
        });
        toast.success(`🆕 Nouveau produit ajouté : ${newProduct.articleName}`);
      });

      // 🔄 Produit mis à jour
      socket.on("productUpdated", (updatedProduct) => {
        console.log("🔄 Produit mis à jour reçu :", updatedProduct);
        setScannedProducts((prev) =>
          prev.map((p) => (p._id === updatedProduct._id ? updatedProduct : p))
        );
      });

      // 🗑️ Produit supprimé (vendeur)
      socket.on("productDeletedVendor", (deletedProduct) => {
        console.log("🗑️ Produit supprimé reçu (vendeur) :", deletedProduct);

        setScannedProducts((prev) =>
          prev.filter((p) => p._id !== deletedProduct._id)
        );

        toast.warn(`🗑️ Produit supprimé : ${deletedProduct.articleName}`);
      });

      // 🔄 Lien barcode mis à jour (émis par le backend)
      socket.on("vendorLinkUpdated", (data) => {
        console.log("🔧 [DASH] ✅ vendorLinkUpdated reçu", data);
        setLinkedProductsKey((k) => k + 1);
      });

      // 🔗 Lien barcode supprimé (émis par le backend)
      socket.on("vendorLinkDeleted", (data) => {
        console.log("🔧 [DASH] ✅ vendorLinkDeleted reçu", data);
        setLinkedProductsKey((k) => k + 1);
      });

      // 📊 Scan barcode enregistré → actualise le compteur de scans + les KPI globaux
      socket.on("barcodeScanRegistered", (data) => {
        console.log("🔧 [DASH] ✅ barcodeScanRegistered reçu", data);
        setLinkedProductsKey((k) => k + 1);
        setStatsKey((k) => k + 1);
      });

      // 📊 Scan QR enregistré → actualise le compteur de scans + les KPI globaux
      socket.on("qrScanRegistered", (data) => {
        console.log("🔧 [DASH] ✅ qrScanRegistered reçu", data);
        setLinkedProductsKey((k) => k + 1);
        setStatsKey((k) => k + 1);
      });

      console.log("🔧 [DASH] listeners barcode attachés — socketId:", socket.id);

      return () => {
        socket.off("productCreatedVendor");
        socket.off("productUpdated");
        socket.off("productDeletedVendor");
        socket.off("vendorLinkUpdated");
        socket.off("vendorLinkDeleted");
        socket.off("barcodeScanRegistered");
        socket.off("qrScanRegistered");
      };
    }, []);

    const resetFilters = async () => {
      setStartDate("");
      setEndDate("");
      setProductStats(null);
      try {
        const res = await axios.get("/products");
        setScannedProducts(res.data);
        scrollToTable();
        toast.success("🔄 Filtres réinitialisés.");
      } catch (err) {
        toast.error("❌ Impossible de réinitialiser les filtres.");
      }
    };

    const handleProductSelect = (e) => {
      const prod = scannedProducts.find(p => p._id === e.target.value);
      if (prod) startEdit(prod);
      setSelectedProductId(e.target.value);
    };

    const startEdit = (prod) => {
      console.log("🧩 Ouverture modale pour :", prod);
      setEditingProductId(prod._id);
      setEditedProduct({ ...prod });
    };

    const cancelEdit = () => {
      setEditingProductId(null);
      setEditedProduct({});
      setSelectedProductId("");
    };

    const saveEdit = async () => {
      try {
        const response = await axios.put(`/products/${editingProductId}`, editedProduct);
        toast.success("✅ Produit mis à jour");
        scrollToTable();
        const updated = scannedProducts.map(p =>
          p._id === editingProductId ? { ...p, ...editedProduct } : p
        );
        setScannedProducts(updated);
        socket.emit("productUpdated", response.data); // ✅ notifie tous les clients
        cancelEdit();
      } catch (err) {
        console.error("❌ Erreur mise à jour produit :", err);
        toast.error("❌ Impossible de mettre à jour ce produit.");
      }
    };

    // Édition inline QR depuis UnifiedProductTable — garde la logique API + state + socket ici
    const saveQRInline = async (productId, editedData) => {
      try {
        const response = await axios.put(`/products/${productId}`, editedData);
        setScannedProducts((prev) =>
          prev.map((p) => (p._id === productId ? { ...p, ...editedData } : p))
        );
        socket.emit("productUpdated", response.data);
        toast.success("✅ Produit mis à jour");
        return true;
      } catch (err) {
        console.error("❌ Erreur mise à jour produit (inline) :", err);
        toast.error("❌ Impossible de mettre à jour ce produit.");
        return false;
      }
    };

    const qrRef = useRef(null); // ✅ ref pour ciblage QR code
    const storeQrRef = useRef(null); // ref pour le QR code d'entrée magasin
    const navigate = useNavigate();

    useEffect(() => {
      const storedUser = localStorage.getItem("user");
      if (!storedUser) {
        toast.error("⛔ Accès refusé. Veuillez vous connecter.");
        navigate("/login");
      }
    }, [navigate]);

    useEffect(() => {
      const fetchStats = async () => {
        try {
          const storedUser = JSON.parse(localStorage.getItem("user"));
          const token = storedUser?.token;
          const vendorId = storedUser?.id;

          if (!vendorId || !token) {
            console.warn("⚠️ Pas d'identifiant ou de token — stats non chargées");
            return;
          }

          console.log(`🔧 [DASH fetchStats] URL=/scans/stats/${vendorId} statsKey=${statsKey}`);

          const res = await axios.get(`/scans/stats/${vendorId}`, {
            headers: { Authorization: `Bearer ${token}` },
          });

          const { totalScans, scansToday } = res.data;
          console.log("🔧 [DASH fetchStats] réponse:", res.data);

          setStats({ totalScans, scansToday });

          // Intérêt communautaire — scans community antérieurs sur les produits référencés
          try {
            const ciRes = await axios.get(`/vendor-links/community-interest/${vendorId}`);
            setCommunityInterest(ciRes.data);
          } catch (ciErr) {
            console.warn("⚠️ Impossible de charger l'intérêt communautaire :", ciErr.message);
          }
        } catch (err) {
          console.error("❌ Erreur récupération stats vendeur :", err);
        }
      };

      if (user?.role === "vendeur" && user?.id) {
        fetchStats();
      }
    }, [user?.id, user?.role, statsKey]);

    
    // ✅ Récupération de l’adresse boutique du vendeur au montage
    useEffect(() => {
      const fetchVendorAddress = async () => {
        try {
          const stored = JSON.parse(localStorage.getItem("user"));
          const token = stored?.token;

          if (!token || !user?.id) return;

          const res = await axios.get(`/auth/${user.id}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          if (res.data?.location) {
            setVendorAddress(res.data.location.address || "");
            setVendorCity(res.data.location.city || "");
          }
          if (res.data?.registered_at) {
            setUser(prev => ({ ...prev, registered_at: res.data.registered_at }));
          }
        } catch (err) {
          console.error("❌ Erreur récupération adresse vendeur :", err);
        }
      };

      if (user?.role === "vendeur") fetchVendorAddress();
    }, []);

    useEffect(() => {
      if (scannedProducts && scannedProducts.length === 0 && !location.state?.tab) {
        setActiveTab("manage");
      }
    }, [scannedProducts]);

    // ── ONGLET "MON MAGASIN" — chargement initial + Socket.io newScan ─
    useEffect(() => {
      if (user?.role !== "vendeur") return;
      fetchStore();
      fetchStoreStats();
      fetchLiveScans();

      socket.on("newScan", (data) => {
        setLiveScans((prev) => [data.scan, ...prev].slice(0, 20));
      });

      return () => {
        socket.off("newScan");
      };
    }, [fetchStore, fetchStoreStats, fetchLiveScans]);

    const handleAddressSelect = async (addr) => {
      console.log("📍 [handleAddressSelect] addr reçu :", { label: addr.label, city: addr.city, postcode: addr.postcode, lat: addr.lat, lng: addr.lng });
      const city = addr.city || addr.label?.match(/\d{5}\s+(.+)$/)?.[1] || "";
      const body = { address: addr.label, city };
      console.log("📤 [handleAddressSelect] body envoyé à l’API :", body);
      try {
        const response = await axios.put("/auth/update-address", body);
        console.log("✅ [handleAddressSelect] réponse :", response.status, response.data);

        const newLocation = response.data.location;

        // 🟢 Mise à jour de React
        setVendorAddress(newLocation.address);
        setVendorCity(newLocation.city);

        // 🟢 Mise à jour immédiate du localStorage
        const storedUser = JSON.parse(localStorage.getItem("user")) || {};
        storedUser.location = newLocation;
        localStorage.setItem("user", JSON.stringify(storedUser));

        toast.success("📍 Adresse enregistrée !");
      } catch (error) {
        console.error("❌ [handleAddressSelect] ERREUR :", {
          status: error.response?.status,
          data: error.response?.data,
          message: error.message,
        });
        toast.error("❌ Impossible d’enregistrer l’adresse.");
      }
    };
    
    const addTestScan = async () => {
      try {
        await axios.post(`${API_URL}/add-test`, { status: customStatus }, {
          headers: {
            "Content-Type": "application/json",
            "x-secret-key": "starkShield272418",
          },
        });
        toast.success(`✅ Scan "${customStatus}" ajouté !`);
      } catch (error) {
        console.error("❌ Erreur ajout scan test :", error);
        toast.error("❌ Impossible d’ajouter le scan test");
      }
    };

    const handleProductChange = (e) => {
  setNewProduct({ ...newProduct, [e.target.name]: e.target.value });
};

    const handleProductSubmit = async (e) => {
  e.preventDefault();
  const { productId, articleName, description, status: productStatus } = newProduct;

      try {
        const qrData = `${window.location.origin}/product/${productId}`; // ✅ on le définit d’abord

        await axios.post(PRODUCT_API, {
          productId,
          articleName,
          description,
          status: productStatus,
          ownerId: user?.id,
          ownerName: user?.name,
          location: {
            address: vendorAddress,
            city: vendorCity,
          },
          city: vendorCity, // champ utilisé pour la carte client
        });

        toast.success("✅ Produit ajouté avec succès !");
        scrollToTable();
        setNewProduct({ productId: "", articleName: "", description: "", status: "en stock" });
        setGeneratedQR(qrData);
        setTimeout(() => {
          if (qrRef.current) {
            qrRef.current.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
        }, 100);
      } catch (err) {
        console.error("❌ Erreur création produit :", err);
        const message = err.response?.data?.error || "Erreur inconnue";
        toast.error("❌ Création échouée : " + message);
      }
};

    const generateQRImage = async (text) => {
      try {
        const dataUrl = await QRCode.toDataURL(text);
        const res = await fetch(dataUrl);
        const blob = await res.blob();
        return blob;
      } catch (err) {
        console.error("Erreur QRCode (dataURL):", err);
        throw err;
      }
    };


    const handleCSVImport = async (file) => {
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: async function (results) {
          const produits = results.data
          .map((prod) => ({
            productId: (prod.productId || prod["﻿productId"])?.trim(),
            articleName: prod.articleName?.trim(),
            description: prod.description?.trim() || "",
            status: prod.status?.trim() || "en stock"
          }))
          .filter((prod) => prod.productId && prod.articleName);
          console.table(produits);

          const zip = new JSZip();
          let success = 0;
          for (const prod of produits) {
            console.log("📦 Produit à créer :", prod);
            try {
              const city = vendorLocation
                ? await getCityFromCoords(vendorLocation.lat, vendorLocation.lng)
                : "";

              await axios.post(PRODUCT_API, {
                ...prod,
                ownerId: user?.id,
                ownerName: user?.name,
                location: vendorLocation,
              });

              
              const qrUrl = `${window.location.origin}/scans/product/${prod.productId}`;
              const blob = await generateQRImage(qrUrl);
              zip.file(`qr-${prod.productId}.png`, blob);
              success++;
            } catch (err) {
              console.warn("❌ Erreur sur :", prod.productId);
              console.error("🛠️ Détail de l'erreur : ", err);
            }
          }
          const content = await zip.generateAsync({ type: "blob" });
          setZipReady(content);
          toast.success(`✅ ${success} produit(s) importé(s) avec QR !`);
        },
      });
    };

    const generateAllQRCodes = async () => {
      try {
        const userId = user?.id;
        if (!userId) {
          toast.error("Utilisateur non identifié !");
          return;
        }

        // Filtrer uniquement les produits du vendeur connecté
        const vendorProducts = scannedProducts.filter(
          (product) => product.ownerId === userId
        );

        if (!vendorProducts.length) {
          toast.info("Aucun produit à générer pour ce compte vendeur.");
          return;
        }

        const zip = new JSZip();

        for (const product of vendorProducts) {
          const url = `${window.location.origin}/product/${product.productId}`;
          const qrDataUrl = await QRCode.toDataURL(url);
          const response = await fetch(qrDataUrl);
          const blob = await response.blob();
          const safeName = (product.articleName || "Produit").replace(/[^a-z0-9]/gi, "_");
          zip.file(`qr-${product.productId}-${safeName}.png`, blob);
        }

        const content = await zip.generateAsync({ type: "blob" });
        saveAs(content, `qr-codes-${user.name || "vendeur"}.zip`);

        toast.success(`✅ ${vendorProducts.length} QR code(s) généré(s) pour ${user.name || "ce vendeur"} !`);
      } catch (error) {
        console.error("Erreur lors de la génération des QR codes vendeur :", error);
        toast.error("❌ Échec de la génération des QR codes.");
      }
    };



    const handleScanSuccess = async (url) => {
      if (url === lastScanned) return;
      setLastScanned(url);
      setTimeout(() => {
        setLastScanned(null);
      }, 3000); // ⏱️ Cooldown de 3 secondes
      try {
        const productId = url.split("/").pop();
        await axios.post("/scans", {
          productId,
          userId: "661000000000000000000000"
        });
        toast.success(`✅ Produit ${productId} scanné et enregistré !`);
      } catch (error) {
        console.error("❌ Erreur enregistrement scan :", error);
        toast.error("❌ Échec de l'enregistrement.");
      }
    };

    const fetchProductStats = async () => {
      try {
        const query = productId || productName;

        if (!query) {
          toast.warn("Veuillez entrer un nom ou un ID de produit.");
          return;
        }

        // 🔍 Recherche locale dans les produits du vendeur
        const matches = scannedProducts.filter((p) => {
          return (
            p.productId === query ||
            p.articleName.toLowerCase() === query.toLowerCase() ||
            p.articleName.toLowerCase().includes(query.toLowerCase())
          );
        });

        // ❌ Aucun produit trouvé
        if (matches.length === 0) {
          toast.error("Aucun produit ne correspond à votre recherche.");
          return;
        }

        // 🟡 Plusieurs produits trouvés → ambiguïté
        if (matches.length > 1) {
          toast.warn("Plusieurs produits correspondent. Affinez votre recherche.");
          return;
        }

        // 🎯 Produit trouvé
        const product = matches[0];
        const realId = product.productId;

        // 🔎 Stats avec ou sans filtre date
        let apiUrl = `/scans/stats/product/${realId}`;

        if (startDate && endDate) {
          apiUrl += `?start=${startDate}&end=${endDate}`;
        }

        const res = await axios.get(apiUrl);

        setProductStats({
          ...res.data,
          productId: realId,
          name: product.articleName
        });

        // 👉 scroll pour aller où il faut
        setTimeout(() => {
          const statsBlock = document.getElementById("stats-result");
          statsBlock?.scrollIntoView({ behavior: "smooth" });
        }, 150);

      } catch (err) {
        console.error("❌ Erreur recherche :", err);
        toast.error("Impossible de récupérer les statistiques.");
      }
    };


    const clearProductStats = () => {
      setProductStats(null);
      setProductId("");
      setProductName("");
    };

    const deleteProduct = async (id, name) => {
      if (!window.confirm(`🗑️ Supprimer le produit "${name}" ?`)) return;
      try {
        const res = await axios.delete(`/products/${id}`);
        const deletedMessage = res.data?.message || `🗑️ Produit supprimé : ${name}`;
        toast.success(deletedMessage);
        console.log(deletedMessage);
        setScannedProducts((prev) => prev.filter((p) => p._id !== id));
        scrollToTable();
        socket.emit("productDeletedVendor", {
          _id: id,
          articleName: name
        });
      } catch (err) {
        console.error("❌ Erreur suppression :", err);
        toast.error("❌ Impossible de supprimer ce produit.");
      }
    };

    const togglePushSubscription = async () => {
      try {
        const newStatus = !isSubscribedToPush;
        console.log("🧭 togglePushSubscription déclenché !");
        console.log("➡️ Nouveau statut :", newStatus, "| Utilisateur :", user?.id);

        const res = await axios.put("/auth/update-push", {
          subscribedToPush: newStatus,
          userId: user?.id,
        });

        console.log("✅ Réponse du backend :", res.data);

        const updatedUser = { ...user, subscribedToPush: newStatus };
        localStorage.setItem("user", JSON.stringify(updatedUser));
        setIsSubscribedToPush(newStatus);

        toast.success(newStatus ? "🔔 Notifications activées !" : "🔕 Notifications désactivées !");
      } catch (err) {
        console.error("❌ Erreur togglePushSubscription :", err);
        toast.error("❌ Impossible de mettre à jour la notification push.");
      }
    };

    const DASH_TABS = ["overview", "products", "manage", "analyse", "profil", ...(user?.role === "vendeur" ? ["store"] : [])];

    const swipeHandlers = useSwipeable({
      onSwipedLeft: () => {
        const idx = DASH_TABS.indexOf(activeTab);
        if (idx < DASH_TABS.length - 1) setActiveTab(DASH_TABS[idx + 1]);
      },
      onSwipedRight: () => {
        const idx = DASH_TABS.indexOf(activeTab);
        if (idx > 0) setActiveTab(DASH_TABS[idx - 1]);
      },
      delta: 50,
      trackTouch: true,
      trackMouse: false,
      preventScrollOnSwipe: true,
    });

    //redirection si l'utilisateur est un client
    if (user?.role === "client") {
      window.location.href = "/client";
      return null;
    }

    const downloadQR = () => {
      try {
        const canvas = qrRef.current?.querySelector("canvas") || qrRef.current;
        if (!canvas) {
          toast.error("❌ QR code non prêt !");
          return;
        }

        const url = canvas.toDataURL("image/png");
        const a = document.createElement("a");
        a.href = url;
        a.download = `qr-${newProduct.productId || "produit"}.png`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } catch (err) {
        console.error("Erreur téléchargement QR :", err);
        toast.error("❌ Impossible de télécharger le QR code.");
      }
    };

    const handleLogout = async () => {
      const fcmToken = localStorage.getItem("fcm_token");
      try { await axios.post("/auth/logout", { fcmToken }); } catch { /* best-effort */ }
      localStorage.removeItem("user");
      localStorage.removeItem("fcm_token");
      window.location.href = "/login";
    };

    const downloadStoreQR = () => {
      try {
        const canvas = storeQrRef.current?.querySelector("canvas") || storeQrRef.current;
        if (!canvas) {
          toast.error("❌ QR code non prêt !");
          return;
        }
        const url = canvas.toDataURL("image/png");
        const a = document.createElement("a");
        a.href = url;
        a.download = `qr-entree-${store?.name || "magasin"}.png`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } catch (err) {
        console.error("Erreur téléchargement QR magasin :", err);
        toast.error("❌ Impossible de télécharger le QR code.");
      }
    };

            return (
          <div className="vd-wrapper" {...swipeHandlers}>

            {/* ── Modaux globaux ── */}
            {showHelp && <HelpModal onClose={() => setShowHelp(false)} />}

            {/* ── Modal suppression compte ── */}
            {showDeleteModal && (
              <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center", padding: "16px" }}>
                <div style={{ background: "white", borderRadius: "16px", padding: "28px 24px", width: "100%", maxWidth: "360px", boxShadow: "0 8px 40px rgba(0,0,0,0.2)" }}>
                  <p style={{ fontSize: "15px", fontWeight: 700, color: "#dc2626", marginBottom: "8px" }}>
                    🗑️ Supprimer mon compte
                  </p>
                  <p style={{ fontSize: "12px", color: "#475569", marginBottom: "16px", lineHeight: 1.6 }}>
                    Cette action est irreversible. Toutes vos donnees seront effacees.
                  </p>
                  {!user?.email ? (
                    <>
                      <label style={{ display: "block", fontSize: "12px", fontWeight: 600, color: "#374151", marginBottom: "6px" }}>
                        Tes 12 mots de recuperation
                      </label>
                      <textarea
                        value={deleteSeedPhrase}
                        onChange={(e) => setDeleteSeedPhrase(e.target.value)}
                        placeholder="mot1 mot2 mot3 ... mot12"
                        autoCapitalize="none"
                        autoCorrect="off"
                        spellCheck={false}
                        rows={3}
                        style={{
                          width: "100%", padding: "10px 12px", border: "1.5px solid #CBD5E1",
                          borderRadius: "8px", fontSize: "13px", background: "#F8FAFC",
                          color: "#1e293b", boxSizing: "border-box", resize: "vertical",
                          fontFamily: "inherit", lineHeight: 1.6, marginBottom: "12px", display: "block"
                        }}
                      />
                    </>
                  ) : (
                    <>
                      <label style={{ display: "block", fontSize: "12px", fontWeight: 600, color: "#374151", marginBottom: "6px" }}>
                        Mot de passe
                      </label>
                      <input
                        type="password"
                        value={deletePassword}
                        onChange={(e) => setDeletePassword(e.target.value)}
                        placeholder="Votre mot de passe"
                        style={{
                          width: "100%", padding: "10px 12px", border: "1.5px solid #CBD5E1",
                          borderRadius: "8px", fontSize: "13px", background: "#F8FAFC",
                          color: "#1e293b", boxSizing: "border-box", marginBottom: "12px", display: "block"
                        }}
                      />
                    </>
                  )}
                  <button
                    onClick={handleDeleteConfirm}
                    disabled={deleteLoading}
                    style={{
                      width: "100%", padding: "11px", background: "#dc2626", color: "white",
                      border: "none", borderRadius: "8px", fontSize: "14px", fontWeight: 700,
                      cursor: "pointer", marginBottom: "8px"
                    }}
                  >
                    {deleteLoading ? "Suppression..." : "Supprimer definitivement"}
                  </button>
                  <button
                    onClick={() => setShowDeleteModal(false)}
                    style={{
                      width: "100%", padding: "11px", background: "#f1f5f9", color: "#475569",
                      border: "none", borderRadius: "8px", fontSize: "14px", fontWeight: 600,
                      cursor: "pointer"
                    }}
                  >
                    Annuler
                  </button>
                </div>
              </div>
            )}
            <ToastContainer
              position="top-right"
              autoClose={4000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="colored"
            />

            {/* FCM désactivé v1.1
            {showNotifModal && (
              <EnableNotificationsModal
                userId={user?.id}
                onClose={() => setShowNotifModal(false)}
              />
            )}
            */}

            <Modal
              open={!!editingProductId}
              onClose={cancelEdit}
              title="🛠️ Modifier le produit"
              initialFocusSelector="#edit-name"
            >
              <div className="vd-form-group">
                <label className="vd-label">Nom du produit</label>
                <input
                  id="edit-name"
                  className="vd-input"
                  value={editedProduct.articleName || ""}
                  onChange={(e) => setEditedProduct({ ...editedProduct, articleName: e.target.value })}
                  placeholder="Nom du produit"
                />
              </div>
              <div className="vd-form-group">
                <label className="vd-label">Description</label>
                <textarea
                  className="vd-textarea"
                  value={editedProduct.description || ""}
                  onChange={(e) => setEditedProduct({ ...editedProduct, description: e.target.value })}
                  placeholder="Description"
                  rows={4}
                />
              </div>
              <div className="vd-form-group">
                <label className="vd-label">Statut</label>
                <select
                  className="vd-select"
                  value={editedProduct.status || "en stock"}
                  onChange={(e) => setEditedProduct({ ...editedProduct, status: e.target.value })}
                >
                  <option value="en stock">Disponible</option>
                  <option value="promotion">Promotion</option>
                  <option value="indisponible">Indisponible</option>
                </select>
              </div>
              <div className="vd-btn-row">
                <button className="vd-btn-primary" onClick={saveEdit}>💾 Enregistrer</button>
                <button className="vd-btn-ghost" onClick={cancelEdit}>Annuler</button>
              </div>
            </Modal>

            {/* ── HEADER ── */}
            <header className="vd-header">
              <div className="vd-header-top">
                <div style={{ minWidth: 0, flex: 1 }}>
                  <span className="vd-header-role">Espace vendeur</span>
                  <h1 className="vd-header-name">{editNameValue || user?.name}</h1>
                </div>
                <div className="vd-header-actions">
                  <button
                    className="vd-logout-header"
                    onClick={handleLogout}
                  >
                    Déconnexion
                  </button>
                  <button className="vd-header-btn" onClick={() => setShowHelp(true)} title="Aide">❓</button>
                  <button className="vd-header-btn" onClick={() => setActiveTab("profil")} title="Profil">👤</button>
                </div>
              </div>
              <div className="vd-kpi-row">
                <div className="vd-kpi">
                  <span className="vd-kpi-n">{stats.totalScans}</span>
                  <span className="vd-kpi-l">Scans</span>
                </div>
                <div className="vd-kpi">
                  <span className="vd-kpi-n">{stats.scansToday}</span>
                  <span className="vd-kpi-l">Aujourd'hui</span>
                </div>
                <div className="vd-kpi">
                  <span className="vd-kpi-n">{totalProducts}</span>
                  <span className="vd-kpi-l">Produits</span>
                </div>
              </div>
            </header>

            {/* ── BANNIÈRE VALIDATION SUPERADMIN ── */}
            {user?.role === "vendeur" && user?.superadmin_validated === false && (
              <div style={{
                background: "#FEF3C7",
                border: "1px solid #F59E0B",
                color: "#92400E",
                padding: "12px 16px",
                borderRadius: "10px",
                margin: "12px 16px 0",
                fontSize: "13px",
                lineHeight: 1.5,
              }}>
                ⏳ Votre espace vendeur est en cours de validation. Vous pourrez envoyer des notifications dès que notre équipe aura validé votre compte.
              </div>
            )}

            {/* ── CONTENU ── */}
            <div className="vd-content">

              {/* FCM désactivé v1.1
              {typeof Notification !== "undefined" && Notification.permission === "denied" && (
                <div className="vd-notif-warning">
                  <span>🔕</span>
                  <span style={{ flex: 1, minWidth: 0 }}>
                    Notifications désactivées.{" "}
                    <button
                      onClick={() => Notification.requestPermission()}
                      style={{ fontWeight: 700, textDecoration: "underline", background: "none", border: "none", color: "#92400E", cursor: "pointer", padding: 0 }}
                    >
                      Réactiver
                    </button>
                  </span>
                </div>
              )}
              {typeof Notification !== "undefined" && Notification.permission === "denied" && <NotificationWarning />}
              */}

              {/* ── ONGLET 1 : APERÇU ── */}
              {activeTab === "overview" && (
                <>
                  <UXHint
                    id="dash_overview"
                    text="Ajoutez vos produits et suivez leurs performances en temps réel depuis cet espace."
                  />

                  {user?.role === "vendeur" && (
                    <>
                      {/* KPI cards */}
                      <div className="vd-kpi-grid">
                        <div className="vd-kpi-card">
                          <div className="vd-kpi-icon" style={{ background: "#FFF0F6" }}>💓</div>
                          <div style={{ minWidth: 0 }}>
                            <span className="vd-kpi-card-n">{stats.totalScans}</span>
                            <span className="vd-kpi-card-l">Scans totaux</span>
                          </div>
                        </div>
                        <div className="vd-kpi-card">
                          <div className="vd-kpi-icon" style={{ background: "#FFF8F0" }}>✨</div>
                          <div style={{ minWidth: 0 }}>
                            <span className="vd-kpi-card-n">{stats.scansToday}</span>
                            <span className="vd-kpi-card-l">Aujourd'hui</span>
                          </div>
                        </div>
                        <div className="vd-kpi-card">
                          <div className="vd-kpi-icon" style={{ background: "#F0F9FF" }}>📦</div>
                          <div style={{ minWidth: 0 }}>
                            <span className="vd-kpi-card-n">{totalProducts}</span>
                            <span className="vd-kpi-card-l">Produits</span>
                          </div>
                        </div>
                      </div>

                      {/* Intérêt communautaire */}
                      {communityInterest.total > 0 && (
                        <div className="vd-community-card">
                          <div className="vd-community-top">
                            <div className="vd-community-icon">👀</div>
                            <div className="vd-community-body">
                              <span className="vd-community-lbl">Intérêt communautaire</span>
                              <span className="vd-community-n">{communityInterest.total}</span>
                              <span className="vd-community-sub">
                                client{communityInterest.total > 1 ? "s" : ""} avai{communityInterest.total > 1 ? "ent" : "t"} repéré {(communityInterest?.details ?? []).length > 1 ? "ces produits" : "ce produit"} avant votre référencement
                              </span>
                            </div>
                          </div>
                          {(communityInterest?.details ?? []).length > 0 && (
                            <ul className="vd-community-tags">
                              {(communityInterest?.details ?? []).map((d) => (
                                <li key={d.barcode} className="vd-community-tag">
                                  {d.name} ({d.count})
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                      )}
                    </>
                  )}

                  {/* Graphique */}
                  {chartData && (
                    <div className="vd-chart-card">
                      <div style={{ width: "100%", overflowX: "auto" }}>
                        <Line
                          data={chartData}
                          options={{
                            responsive: true,
                            maintainAspectRatio: false,
                            plugins: { legend: { position: "top" } },
                          }}
                          height={200}
                        />
                      </div>
                    </div>
                  )}

                  {/* Ma boutique */}
                  {user?.role === "vendeur" && (
                    <>
                      <div className="vd-section-header">
                        <span className="vd-section-title">Ma boutique</span>
                        {!vendorAddress && (
                          <button className="vd-see-all" onClick={() => setActiveTab("profil")}>
                            Renseigner
                          </button>
                        )}
                      </div>
                      {vendorAddress ? (
                        <div className="vd-store-card">
                          <div className="vd-store-address">{vendorAddress}</div>
                          {vendorCity && <div className="vd-store-city">📍 {vendorCity}</div>}
                        </div>
                      ) : (
                        <div className="vd-card" style={{ color: "#94A3B8", fontSize: "13px", fontStyle: "italic" }}>
                          Aucune adresse enregistrée.
                        </div>
                      )}
                    </>
                  )}

                  {/* Raccourcis */}
                  <div className="vd-section-header">
                    <span className="vd-section-title">Accès rapide</span>
                  </div>
                  <div className="vd-shortcuts">
                    <button className="vd-shortcut" onClick={() => setActiveTab("products")}>
                      <span className="vd-shortcut-icon">📦</span>
                      <span className="vd-shortcut-label">Produits</span>
                      <span className="vd-shortcut-sub">{totalProducts} réf.</span>
                    </button>
                    <button className="vd-shortcut" onClick={() => setActiveTab("manage")}>
                      <span className="vd-shortcut-icon">➕</span>
                      <span className="vd-shortcut-label">Ajouter</span>
                      <span className="vd-shortcut-sub">QR · barcode</span>
                    </button>
                    <button className="vd-shortcut" onClick={() => setActiveTab("analyse")}>
                      <span className="vd-shortcut-icon">📊</span>
                      <span className="vd-shortcut-label">Analyse</span>
                      <span className="vd-shortcut-sub">Stats produit</span>
                    </button>
                  </div>

                  {/* ── Blocs enrichis ── */}
                  {user?.id && <>
                    <RecentScansBlock vendorId={user.id} />
                    <TopProductsBlock vendorId={user.id} />
                    <VendorActivityBlocks
                      vendorId={user.id}
                      scansToday={stats.scansToday}
                      monthlyGoal={store?.monthlyGoal ?? 50}
                      onGoalClick={() => setActiveTab("store")}
                    />
                  </>}
                </>
              )}

              {/* ── ONGLET 2 : PRODUITS ── */}
              {activeTab === "products" && (
                <div id="product-table">
                  <div className="vd-section-header">
                    <span className="vd-section-title">Mes produits</span>
                  </div>
                  <UnifiedProductTable
                    qrProducts={scannedProducts.filter((p) => p.ownerId === user?.id)}
                    user={user}
                    onSaveQR={saveQRInline}
                    onDeleteQR={(id, name) => deleteProduct(id, name)}
                    refreshKey={linkedProductsKey}
                    onTotalChange={setTotalProducts}
                  />
                </div>
              )}

              {/* ── ONGLET 3 : GÉRER ── */}
              {activeTab === "manage" && user?.role === "vendeur" && (
                <div id="add-product-section">
                  <div className="vd-section-header">
                    <span className="vd-section-title">Gérer mes produits</span>
                  </div>

                  <UXHint
                    id="dash_manage_intro"
                    text="Ajoutez vos produits pour les rendre visibles aux clients lors de leurs scans."
                  />

                  <div className="vd-intro-badges">
                    <span className="vd-intro-badge" style={{ background: "#E0F2FE", color: "#0369A1" }}>
                      🔹 QR code : créez vos propres produits
                    </span>
                    <span className="vd-intro-badge" style={{ background: "#EDE9FE", color: "#5B21B6" }}>
                      🔹 Code-barres : liez des produits existants
                    </span>
                  </div>

                  <BarcodeProductManager
                    user={user}
                    onSuccess={() => setLinkedProductsKey(k => k + 1)}
                    initialBarcode={barcodeFromUrl}
                  />

                  {/* Ajouter un produit QR */}
                  <div className="vd-card">
                    <h3 className="vd-card-title">🛒 Ajouter un produit QR</h3>
                    <form onSubmit={handleProductSubmit}>
                      <div className="vd-form-group">
                        <label className="vd-label">Nom du produit *</label>
                        <input
                          type="text"
                          name="articleName"
                          className="vd-input"
                          placeholder="Ex : Sac en cuir naturel"
                          value={newProduct.articleName}
                          onChange={handleProductChange}
                          required
                        />
                      </div>
                      <div className="vd-form-group">
                        <label className="vd-label">Description *</label>
                        <textarea
                          name="description"
                          className="vd-textarea"
                          placeholder="Décrivez votre produit..."
                          value={newProduct.description}
                          onChange={handleProductChange}
                          required
                        />
                      </div>
                      <div className="vd-form-group">
                        <label className="vd-label">Statut</label>
                        <select
                          name="status"
                          className="vd-select"
                          value={newProduct.status}
                          onChange={handleProductChange}
                        >
                          <option value="en stock">Disponible</option>
                          <option value="promotion">Promotion</option>
                          <option value="indisponible">Indisponible</option>
                        </select>
                      </div>
                      <button type="submit" className="vd-btn-primary" style={{ width: "100%" }}>
                        ➕ Créer le produit
                      </button>
                    </form>

                    {generatedQR && (
                      <>
                        <div className="vd-qr-preview" ref={qrRef}>
                          <QRCodeCanvas
                            value={generatedQR}
                            size={180}
                            includeMargin={true}
                            bgColor="#ffffff"
                            fgColor="#000000"
                          />
                          <p className="vd-qr-hint">Scannez ce QR pour tester la fiche produit</p>
                        </div>
                        <div className="vd-btn-row">
                          <button type="button" onClick={downloadQR} className="vd-btn-primary">
                            ⬇️ Télécharger
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              setGeneratedQR(null);
                              setNewProduct({ productId: "", articleName: "", description: "", status: "en stock" });
                            }}
                            className="vd-btn-secondary"
                          >
                            ➕ Continuer
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              setGeneratedQR(null);
                              setNewProduct({ productId: "", articleName: "", description: "", status: "en stock" });
                              setActiveTab("products");
                            }}
                            className="vd-btn-ghost"
                          >
                            ✅ Terminer
                          </button>
                        </div>
                      </>
                    )}
                  </div>

                  {/* Import CSV */}
                  <div className="vd-card">
                    <h3 className="vd-card-title">📁 Importer via CSV</h3>
                    <p style={{ fontSize: "12px", color: "#94A3B8", marginBottom: "12px" }}>
                      Format attendu : productId, articleName, description, status
                    </p>
                    <input
                      type="file"
                      accept=".csv"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) handleCSVImport(file);
                      }}
                      className="vd-file-input"
                    />
                    {zipReady && (
                      <div style={{ textAlign: "center" }}>
                        <button
                          onClick={() => saveAs(zipReady, "qr-codes.zip")}
                          className="vd-btn-primary"
                        >
                          📦 Télécharger les QR en ZIP
                        </button>
                      </div>
                    )}
                  </div>

                  {/* QR en lot */}
                  {scannedProducts.length > 0 && (
                    <div className="vd-card">
                      <h3 className="vd-card-title">📥 QR codes en lot</h3>
                      <p style={{ fontSize: "12px", color: "#94A3B8", marginBottom: "12px" }}>
                        Générez et téléchargez tous vos QR codes en une seule fois.
                      </p>
                      <button onClick={generateAllQRCodes} className="vd-btn-primary" style={{ width: "100%" }}>
                        📦 Télécharger tous les QR codes
                      </button>
                    </div>
                  )}
                </div>
              )}

              {/* ── ONGLET 4 : ANALYSE ── */}
              {activeTab === "analyse" && (
                <div>
                  <div className="vd-section-header">
                    <span className="vd-section-title">Analyse</span>
                  </div>

                  <UXHint
                    id="dash_analyse"
                    text="Consultez les scans par produit pour mieux comprendre la visibilité de votre catalogue."
                  />

                  <div className="vd-card">
                    <h3 className="vd-card-title">🔍 Rechercher un produit</h3>
                    <div className="vd-form-group">
                      <label className="vd-label">ID du produit</label>
                      <input
                        type="text"
                        value={productId}
                        onChange={(e) => setProductId(e.target.value)}
                        className="vd-input"
                        placeholder="Identifiant produit"
                      />
                    </div>
                    <div className="vd-form-group">
                      <label className="vd-label">Nom du produit</label>
                      <input
                        type="text"
                        value={productName}
                        onChange={(e) => setProductName(e.target.value)}
                        className="vd-input"
                        placeholder="Nom du produit"
                      />
                    </div>
                    <div className="vd-btn-row">
                      <button onClick={fetchProductStats} className="vd-btn-primary" style={{ flex: 1 }}>
                        Voir les stats
                      </button>
                      <button onClick={clearProductStats} className="vd-btn-ghost" style={{ flex: 1 }}>
                        Effacer
                      </button>
                    </div>
                  </div>

                  <div className="vd-card">
                    <h3 className="vd-card-title">📅 Filtrer par date</h3>
                    <div className="vd-date-grid">
                      <div className="vd-form-group" style={{ marginBottom: 0 }}>
                        <label className="vd-label">Début</label>
                        <input
                          type="date"
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                          className="vd-input"
                        />
                      </div>
                      <div className="vd-form-group" style={{ marginBottom: 0 }}>
                        <label className="vd-label">Fin</label>
                        <input
                          type="date"
                          value={endDate}
                          onChange={(e) => setEndDate(e.target.value)}
                          className="vd-input"
                        />
                      </div>
                    </div>
                    <div className="vd-btn-row" style={{ marginTop: "12px" }}>
                      <button onClick={fetchFilteredScans} className="vd-btn-primary" style={{ flex: 1 }}>
                        Appliquer
                      </button>
                      <button onClick={resetFilters} className="vd-btn-ghost" style={{ flex: 1 }}>
                        Réinitialiser
                      </button>
                    </div>
                  </div>

                  {productStats && Array.isArray(productStats.scans || productStats) && (
                    <div className="vd-analyse-results" id="stats-result">
                      <div className="vd-analyse-title">
                        📦 {productStats.name}
                        {productStats.productId && (
                          <span style={{ fontSize: "10px", color: "rgba(255,255,255,0.4)", marginLeft: "8px", fontWeight: 400 }}>
                            {productStats.productId}
                          </span>
                        )}
                      </div>
                      <div className="vd-analyse-total">
                        {productStats.total} scan{productStats.total > 1 ? "s" : ""} au total
                      </div>
                      <ul className="vd-analyse-list">
                        {(productStats.scans || productStats).map((scan, index) => (
                          <li key={index} className="vd-analyse-item">
                            <span>{scan.articleName} — {scan.status}</span>
                            <span className="vd-analyse-item-date">
                              {new Date(scan.date).toLocaleString("fr-FR")}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              )}

              {/* ── ONGLET 6 : MON MAGASIN ── */}
              {activeTab === "store" && user?.role === "vendeur" && (
                <div>

                  {/* État 1 : pas encore de magasin */}
                  {!store && (
                    <div className="vd-card">
                      <h3 className="vd-card-title">🏪 Enregistrer mon magasin</h3>
                      <div className="vd-form-group">
                        <label className="vd-label">Nom du magasin</label>
                        <input
                          className="vd-input"
                          value={storeForm.name}
                          onChange={(e) => setStoreForm({ ...storeForm, name: e.target.value })}
                          placeholder="Ex : Épicerie du Centre"
                        />
                      </div>
                      <div className="vd-form-group">
                        <label className="vd-label">Adresse</label>
                        <StoreAutocomplete
                          value={storeForm.address}
                          onChange={(val) => typeof val === "object" && val !== null
                            ? setStoreForm({ ...storeForm, address: val.label, lat: val.lat, lng: val.lng })
                            : setStoreForm({ ...storeForm, address: val, lat: null, lng: null })}
                          disabled={storeLoading}
                          inputStyle={{
                            width: "100%",
                            padding: "11px 14px",
                            border: "1.5px solid #E2E8F0",
                            borderRadius: "12px",
                            fontSize: "13px",
                            color: "#0F172A",
                            background: "white",
                            boxSizing: "border-box"
                          }}
                        />
                      </div>
                      <div className="vd-form-group">
                        <label className="vd-label">SIRET</label>
                        <input
                          className="vd-input"
                          value={storeForm.siret}
                          onChange={(e) => setStoreForm({ ...storeForm, siret: e.target.value })}
                          placeholder="14 chiffres"
                          maxLength={14}
                          inputMode="numeric"
                        />
                      </div>
                      <button
                        className="vd-btn-primary"
                        style={{ width: "100%" }}
                        onClick={handleRegisterStore}
                        disabled={storeLoading}
                      >
                        {storeLoading ? "Enregistrement…" : "Enregistrer"}
                      </button>
                      <p style={{ fontSize: "12px", color: "#94A3B8", marginTop: "10px", textAlign: "center" }}>
                        Un code de validation sera envoyé par courrier à l'adresse du magasin.
                      </p>
                    </div>
                  )}

                  {/* État 2 : magasin enregistré, non vérifié */}
                  {store && !store.verified && (
                    <div className="vd-card">
                      <h3 className="vd-card-title">📬 En attente de validation</h3>
                      <div className="vd-info-list">
                        <div className="vd-info-row">
                          <span className="vd-info-dt">Magasin</span>
                          <span className="vd-info-dd">{store.name}</span>
                        </div>
                        <div className="vd-info-row">
                          <span className="vd-info-dt">Adresse</span>
                          <span className="vd-info-dd">{store.address}</span>
                        </div>
                      </div>
                      {plainCode && (
                        <div style={{
                          background: "#fefce8", border: "1px solid #fde047",
                          borderRadius: "8px", padding: "12px 14px", marginTop: "16px",
                          fontSize: "13px", color: "#713f12", lineHeight: "1.5"
                        }}>
                          🔑 Mode test uniquement — votre code de validation : <strong style={{ letterSpacing: "2px" }}>{plainCode}</strong>
                        </div>
                      )}
                      <div className="vd-form-group" style={{ marginTop: "16px" }}>
                        <label className="vd-label">Code reçu par courrier</label>
                        <input
                          className="vd-input"
                          value={validationCode}
                          onChange={(e) => setValidationCode(e.target.value)}
                          placeholder="123456"
                          maxLength={6}
                          inputMode="numeric"
                        />
                      </div>
                      <div className="vd-btn-row">
                        <button
                          className="vd-btn-primary"
                          style={{ flex: 1 }}
                          onClick={handleValidateStore}
                          disabled={storeLoading}
                        >
                          {storeLoading ? "Validation…" : "Valider mon magasin"}
                        </button>
                        <button
                          className="vd-btn-ghost"
                          style={{ flex: 1 }}
                          onClick={handleRegisterStore}
                          disabled={storeLoading}
                        >
                          Renvoyer un courrier
                        </button>
                      </div>
                    </div>
                  )}

                  {/* État 3 : magasin vérifié */}
                  {store && store.verified && (
                    <>
                      <div className="vd-card">
                        <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "14px" }}>
                          <h3 className="vd-card-title" style={{ margin: 0 }}>✅ {store.name}</h3>
                          <span style={{
                            fontSize: "11px", fontWeight: 700, color: "#16a34a",
                            background: "#dcfce7", borderRadius: "20px", padding: "2px 10px"
                          }}>Vérifié</span>
                        </div>
                        <div className="vd-info-list">
                          <div className="vd-info-row">
                            <span className="vd-info-dt">Scans totaux</span>
                            <span className="vd-info-dd">{storeStats?.total_scans ?? "—"}</span>
                          </div>
                          <div className="vd-info-row">
                            <span className="vd-info-dt">Aujourd'hui</span>
                            <span className="vd-info-dd">{storeStats?.scans_today ?? "—"}</span>
                          </div>
                        </div>
                      </div>

                      {storeStats?.top_products?.length > 0 && (
                        <div className="vd-card">
                          <h3 className="vd-card-title">🏆 Top produits scannés</h3>
                          <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: "8px" }}>
                            {(storeStats?.top_products ?? []).slice(0, 5).map((p, i) => (
                              <li key={p.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: "13px" }}>
                                <span style={{ color: "#475569" }}>
                                  <span style={{ fontWeight: 700, marginRight: "6px" }}>{i + 1}.</span>
                                  {p.articleName}
                                </span>
                                <span style={{ fontWeight: 700, color: "#D41A6E" }}>{p.count} scan{p.count > 1 ? "s" : ""}</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}

                      <div className="vd-card">
                        <h3 className="vd-card-title">🔴 Scans en direct</h3>
                        {liveScans.length === 0 ? (
                          <p style={{ fontSize: "13px", color: "#94A3B8", textAlign: "center", padding: "16px 0" }}>
                            Aucun scan récent
                          </p>
                        ) : (
                          <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: "8px" }}>
                            {liveScans.map((scan, i) => (
                              <li key={scan._id || i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: "13px" }}>
                                <span style={{ color: "#475569", flex: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                  {scan.articleName || scan.barcode || "Produit inconnu"}
                                </span>
                                <span style={{ color: "#94A3B8", fontSize: "11px", flexShrink: 0, marginLeft: "8px" }}>
                                  {new Date(scan.date).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" })}
                                </span>
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>

                      <div className="vd-card">
                        <h3 className="vd-card-title">🎯 Objectif mensuel</h3>
                        <p style={{ fontSize: "12px", color: "#94A3B8", marginBottom: "14px" }}>
                          Fixez le nombre de crushes à atteindre ce mois pour suivre votre progression.
                        </p>
                        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                          <input
                            className="vd-input"
                            type="number"
                            min={1}
                            max={10000}
                            step={10}
                            value={goalInput}
                            onChange={e => setGoalInput(e.target.value)}
                            style={{ flex: 1 }}
                          />
                          <button
                            className="vd-btn-primary"
                            onClick={handleSaveGoal}
                            disabled={goalSaving}
                            style={{ flexShrink: 0 }}
                          >
                            {goalSaving ? "…" : "Enregistrer"}
                          </button>
                        </div>
                        <p style={{ fontSize: "11px", color: "#cbd5e1", marginTop: "8px" }}>
                          Objectif actuel : {store.monthlyGoal ?? 50} crushes / mois
                        </p>
                      </div>

                      <div className="vd-card">
                        <h3 className="vd-card-title">🔲 QR code d'entrée</h3>
                        <p style={{ fontSize: "12px", color: "#94A3B8", marginBottom: "14px" }}>
                          Affichez ce QR code à l'entrée de votre magasin. Les clients qui le scannent seront associés à votre boutique.
                        </p>
                        <div
                          ref={storeQrRef}
                          className="vd-qr-preview"
                          style={{ display: "flex", justifyContent: "center", padding: "20px", marginBottom: "14px" }}
                        >
                          <QRCodeCanvas
                            value={store.entry_qr_code}
                            size={180}
                            includeMargin={true}
                          />
                        </div>
                        <button className="vd-btn-secondary" style={{ width: "100%" }} onClick={downloadStoreQR}>
                          ⬇️ Télécharger le QR code
                        </button>
                      </div>
                    </>
                  )}

                </div>
              )}

              {/* ── ONGLET 5 : PROFIL ── */}
              {activeTab === "profil" && (
                <div>
                  <UXHint
                    id="dash_profil"
                    text="Gérez les informations de votre boutique et complétez votre profil vendeur pour être mieux identifié par vos clients."
                  />

                  <div className="vd-profile-card">
                    <div className="vd-profile-avatar">
                      {(editNameValue || user?.name || "V").split(" ").map(w => w[0]).slice(0, 2).join("").toUpperCase()}
                    </div>
                    <div style={{ minWidth: 0, flex: 1 }}>
                      {editingName ? (
                        <div style={{ display: "flex", gap: "8px", alignItems: "center", marginBottom: "4px" }}>
                          <input
                            className="vd-input"
                            style={{ flex: 1, minWidth: 0, padding: "6px 10px", fontSize: "14px" }}
                            value={editNameValue}
                            onChange={e => setEditNameValue(e.target.value)}
                            onKeyDown={e => { if (e.key === "Enter") handleSaveName(); if (e.key === "Escape") setEditingName(false); }}
                            autoFocus
                            maxLength={60}
                          />
                          <button className="vd-btn-primary" style={{ padding: "6px 12px", minHeight: "36px", fontSize: "13px" }} onClick={handleSaveName}>✓</button>
                          <button className="vd-btn-ghost" style={{ padding: "6px 10px", minHeight: "36px", fontSize: "13px" }} onClick={() => { setEditNameValue(user?.name || ""); setEditingName(false); }}>✕</button>
                        </div>
                      ) : (
                        <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "2px" }}>
                          <div className="vd-profile-name">{editNameValue || user?.name || "—"}</div>
                          <button
                            style={{ background: "none", border: "none", cursor: "pointer", fontSize: "14px", padding: "2px", touchAction: "manipulation", flexShrink: 0 }}
                            onClick={() => setEditingName(true)}
                            title="Modifier le nom"
                          >✏️</button>
                        </div>
                      )}
                      <div className="vd-profile-email">{user?.email || "—"}</div>
                    </div>
                  </div>

                  <div className="vd-card">
                    <h3 className="vd-card-title">Informations</h3>
                    <div className="vd-info-list">
                      <div className="vd-info-row">
                        <span className="vd-info-dt">Rôle</span>
                        <span className="vd-info-dd">{user?.role || "—"}</span>
                      </div>
                      {(user?.registered_at || user?.createdAt) && (
                        <div className="vd-info-row">
                          <span className="vd-info-dt">Membre depuis</span>
                          <span className="vd-info-dd">
                            {new Date(user.registered_at || user.createdAt).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" })}
                          </span>
                        </div>
                      )}
                      <div className="vd-info-row">
                        <span className="vd-info-dt">Adresse</span>
                        <span className="vd-info-dd">{vendorAddress || "Non renseignée"}</span>
                      </div>
                      {vendorCity && (
                        <div className="vd-info-row">
                          <span className="vd-info-dt">Ville</span>
                          <span className="vd-info-dd">{vendorCity}</span>
                        </div>
                      )}
                    </div>
                  </div>

                  {user?.role === "vendeur" && (
                    <div className="vd-card">
                      <h3 className="vd-card-title">🏠 Modifier mon adresse</h3>
                      <AddressAutocomplete onSelect={handleAddressSelect} />
                    </div>
                  )}

                  {/* Bloc 1 — Informations & légal */}
                  <div style={{ background: "white", borderRadius: "14px", padding: "4px 0", marginTop: "12px", border: "1px solid #f1f5f9" }}>
                    {[
                      { label: "ℹ️ À propos", path: "/about" },
                      { label: "💬 Donner mon avis", path: "/feedback" },
                      { label: "💡 FAQ", path: "/faq" },
                      { label: "📋 Évolutions", path: "/evolutions" },
                      { label: "📄 CGU", path: "/cgu" },
                      { label: "🔒 Confidentialité", path: "/privacy" },
                      { label: "⚖️ Mentions légales", path: "/legal" },
                    ].map((link, i, arr) => (
                      <Link
                        key={i}
                        to={link.path}
                        state={{ fromTab: "profil" }}
                        style={{
                          display: "flex", justifyContent: "space-between", alignItems: "center",
                          padding: "14px 16px",
                          borderBottom: i < arr.length - 1 ? "1px solid #f8fafc" : "none",
                          cursor: "pointer", textDecoration: "none", color: "inherit"
                        }}
                      >
                        <span style={{ fontSize: "14px", color: "#475569" }}>{link.label}</span>
                        <span style={{ color: "#cbd5e1" }}>›</span>
                      </Link>
                    ))}
                  </div>

                  {/* Bloc 2 — Préférences */}
                  <div className="vd-card" style={{ marginTop: "12px" }}>
                    <h3 className="vd-card-title">🔔 Notifications push</h3>
                    <div style={{ display: "flex", alignItems: "center", gap: "12px", justifyContent: "space-between" }}>
                      <span style={{ fontSize: "13px", color: "#475569", flex: 1, minWidth: 0 }}>
                        {isSubscribedToPush ? "Activées — vous recevez les alertes en temps réel" : "Désactivées"}
                      </span>
                      <button
                        onClick={togglePushSubscription}
                        className={isSubscribedToPush ? "vd-btn-ghost" : "vd-btn-primary"}
                        style={{ flexShrink: 0 }}
                      >
                        {isSubscribedToPush ? "🔕 Désactiver" : "🔔 Activer"}
                      </button>
                    </div>
                  </div>

                  {/* Bloc 3 — Compte */}
                  <ReportBugButton />
                  <button
                    className="vd-logout-full"
                    onClick={() => navigate("/my-data")}
                    style={{ background: "#f1f5f9", color: "#475569", marginBottom: "8px", border: "1px solid #e2e8f0", marginTop: "12px" }}
                  >
                    📊 Voir mes données
                  </button>
                  <button
                    className="vd-logout-full"
                    onClick={deleteAccount}
                    style={{ background: "#fee2e2", color: "#dc2626", marginBottom: "8px", border: "1px solid #fca5a5" }}
                  >
                    🗑️ Supprimer mon compte
                  </button>
                  <button
                    className="vd-logout-full"
                    onClick={handleLogout}
                  >
                    🚪 Déconnexion
                  </button>
                </div>
              )}

            </div>

            {/* ── NAVIGATION PAR ONGLETS ── */}
            <nav className="vd-tabs">
              {[
                { id: "overview", icon: "📋", label: "Aperçu" },
                { id: "products", icon: "📦", label: "Produits" },
                { id: "manage",   icon: "➕", label: "Gérer" },
                { id: "analyse",  icon: "📊", label: "Analyse" },
                { id: "profil",   icon: "👤", label: "Profil" },
                ...(user?.role === "vendeur" ? [{ id: "store", icon: "🏪", label: "Mon Magasin" }] : []),
              ].map((tab) => (
                <button
                  key={tab.id}
                  className={`vd-tab${activeTab === tab.id ? " active" : ""}`}
                  onClick={() => setActiveTab(tab.id)}
                >
                  <span className="vd-tab-icon">{tab.icon}</span>
                  <span className="vd-tab-label">{tab.label}</span>
                </button>
              ))}
            </nav>
          </div>
        );
  };

// ── Helpers ───────────────────────────────────────────────────────────────
function timeAgo(date) {
  const diff = Math.floor((Date.now() - new Date(date)) / 1000);
  if (diff < 60)   return "il y a quelques secondes";
  if (diff < 3600) return `il y a ${Math.floor(diff / 60)}min`;
  if (diff < 86400) return `il y a ${Math.floor(diff / 3600)}h`;
  return `il y a ${Math.floor(diff / 86400)}j`;
}

const cardStyle = {
  background: "white", borderRadius: "14px", padding: "16px",
  marginTop: "14px", border: "1px solid #f1f5f9",
};
const sectionLabelStyle = {
  fontSize: "11px", fontWeight: 800, textTransform: "uppercase",
  letterSpacing: "0.08em", color: "#94a3b8", marginBottom: "12px", display: "block",
};

// ── Bloc 1 — Derniers scans ────────────────────────────────────────────────
function RecentScansBlock({ vendorId }) {
  const [scans, setScans] = React.useState(null);
  React.useEffect(() => {
    axios.get(`/scans/recent-by-vendor/${vendorId}`)
      .then(r => setScans(r.data.scans))
      .catch(() => setScans([]));
  }, [vendorId]);

  return (
    <div style={cardStyle}>
      <span style={sectionLabelStyle}>Derniers scans</span>
      {scans === null ? (
        <p style={{ fontSize: "12px", color: "#94a3b8" }}>Chargement…</p>
      ) : scans.length === 0 ? (
        <p style={{ fontSize: "12px", color: "#94a3b8" }}>Aucun scan enregistré.</p>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          {scans.map((s, i) => (
            <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 0", borderBottom: i < scans.length - 1 ? "1px solid #f8fafc" : "none" }}>
              <div>
                <div style={{ fontSize: "13px", fontWeight: 600, color: "#0f172a" }}>{s.articleName || "—"}</div>
                {(s.city || s.location_label) && (
                  <div style={{ fontSize: "11px", color: "#94a3b8" }}>📍 {s.location_label || s.city}</div>
                )}
              </div>
              <span style={{ fontSize: "11px", color: "#94a3b8", flexShrink: 0, marginLeft: "8px" }}>{timeAgo(s.date)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── Bloc 2 — Top 3 produits ───────────────────────────────────────────────
function TopProductsBlock({ vendorId }) {
  const [top, setTop] = React.useState(null);
  React.useEffect(() => {
    axios.get(`/products/vendor/${vendorId}/top`)
      .then(r => setTop(r.data.top))
      .catch(() => setTop([]));
  }, [vendorId]);

  const medals = ["🥇", "🥈", "🥉"];
  return (
    <div style={cardStyle}>
      <span style={sectionLabelStyle}>Top produits</span>
      {top === null ? (
        <p style={{ fontSize: "12px", color: "#94a3b8" }}>Chargement…</p>
      ) : top.length === 0 ? (
        <p style={{ fontSize: "12px", color: "#94a3b8" }}>Pas encore de données.</p>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {top.map((p, i) => (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <span style={{ fontSize: "22px", flexShrink: 0 }}>{medals[i]}</span>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: "13px", fontWeight: 700, color: "#0f172a", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{p.articleName}</div>
              </div>
              <span style={{ fontSize: "13px", fontWeight: 800, color: "#D41A6E", flexShrink: 0 }}>{p.scanCount} 💓</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── Blocs 3 + 4 + 5 — Activité, Objectif, Démographie ────────────────────
function VendorActivityBlocks({ vendorId, scansToday, monthlyGoal = 50, onGoalClick }) {
  const [demo, setDemo] = React.useState(null);
  React.useEffect(() => {
    axios.get(`/scans/demographics/${vendorId}`)
      .then(r => setDemo(r.data))
      .catch(() => setDemo(null));
  }, [vendorId]);

  const scansThisMonth     = demo?.scansThisMonth     ?? 0;
  const purchasesThisMonth = demo?.purchasesThisMonth ?? 0;
  const OBJECTIF    = monthlyGoal;
  const progressPct = Math.min(100, Math.round((scansThisMonth / OBJECTIF) * 100));

  const genderColors = { homme: "#3B82F6", femme: "#EC4899", autre: "#8B5CF6", non_renseigne: "#CBD5E1" };
  const genderLabels = { homme: "Hommes", femme: "Femmes", autre: "Autre", non_renseigne: "N/R" };
  const ageLabels    = { "15-25": "15-25", "26-35": "26-35", "36-50": "36-50", "50+": "50+", non_renseigne: "N/R" };

  const totalGender = demo ? Object.values(demo.gender).reduce((a, b) => a + b, 0) : 0;
  const totalAge    = demo ? Object.values(demo.age).reduce((a, b) => a + b, 0)    : 0;

  return (
    <>
      {/* Bloc 3 — Activité récente */}
      <div style={cardStyle}>
        <span style={sectionLabelStyle}>Activité récente</span>
        <div style={{ display: "flex", gap: "12px" }}>
          {[
            { value: scansToday || 0, label: "nouveaux crushes aujourd'hui", emoji: "💓" },
            { value: purchasesThisMonth, label: "achats ce mois", emoji: "🛍️" },
          ].map(({ value, label, emoji }) => (
            <div key={label} style={{ flex: 1, background: "#fdf2f8", borderRadius: "10px", padding: "12px", textAlign: "center", border: "1px solid #fce7f3" }}>
              <div style={{ fontSize: "24px", fontWeight: 900, color: "#D41A6E" }}>{value}</div>
              <div style={{ fontSize: "11px", color: "#94a3b8", marginTop: "4px" }}>{emoji} {label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Bloc 4 — Objectif du mois */}
      <div style={cardStyle}>
        <span style={sectionLabelStyle}>Objectif du mois</span>
        {scansThisMonth > OBJECTIF ? (
          <p style={{ fontSize: "14px", fontWeight: 700, color: "#16a34a", textAlign: "center", padding: "8px 0" }}>
            🎉 Objectif dépassé ce mois !
          </p>
        ) : (
          <>
            <div style={{ background: "#f1f5f9", borderRadius: "100px", height: "10px", overflow: "hidden", marginBottom: "8px" }}>
              <div style={{ height: "100%", width: `${progressPct}%`, background: "linear-gradient(90deg, #D41A6E, #E87010)", borderRadius: "100px", transition: "width 0.5s" }} />
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", fontSize: "12px", color: "#64748b" }}>
              <span style={{ fontWeight: 700 }}>{scansThisMonth} / {OBJECTIF} crushes ce mois</span>
              <span>{progressPct}%</span>
            </div>
            <p style={{ fontSize: "11px", color: "#94a3b8", marginTop: "6px" }}>
              {OBJECTIF - scansThisMonth > 0 ? `Plus que ${OBJECTIF - scansThisMonth} crushes pour atteindre l'objectif !` : "Continuez !"}
            </p>
            {onGoalClick && (
              <button onClick={onGoalClick} style={{ background: "none", border: "none", color: "#D41A6E", fontSize: "12px", cursor: "pointer", padding: "4px 0", fontWeight: 600 }}>
                Modifier l'objectif →
              </button>
            )}
          </>
        )}
      </div>

      {/* Bloc 5 — Démographie clients */}
      <div style={cardStyle}>
        <span style={sectionLabelStyle}>Démographie clients</span>
        {demo === null ? (
          <p style={{ fontSize: "12px", color: "#94a3b8" }}>Chargement…</p>
        ) : totalGender === 0 ? (
          <p style={{ fontSize: "12px", color: "#94a3b8" }}>Pas encore assez de données.</p>
        ) : (
          <>
            <div style={{ fontSize: "11px", fontWeight: 700, color: "#64748b", marginBottom: "8px" }}>Genre</div>
            <div style={{ display: "flex", gap: "6px", alignItems: "flex-end", height: "52px", marginBottom: "14px" }}>
              {Object.entries(demo.gender).map(([key, count]) => {
                const pct = totalGender > 0 ? Math.round((count / totalGender) * 100) : 0;
                return (
                  <div key={key} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: "3px" }}>
                    <div style={{ width: "100%", height: `${Math.max(pct * 0.44, count > 0 ? 3 : 0)}px`, background: genderColors[key], borderRadius: "3px 3px 0 0" }} />
                    <span style={{ fontSize: "9px", color: "#64748b", fontWeight: 600 }}>{genderLabels[key]}</span>
                    {count > 0 && <span style={{ fontSize: "9px", color: "#94a3b8" }}>{pct}%</span>}
                  </div>
                );
              })}
            </div>
            <div style={{ fontSize: "11px", fontWeight: 700, color: "#64748b", marginBottom: "8px" }}>Tranche d'âge</div>
            <div style={{ display: "flex", gap: "6px", alignItems: "flex-end", height: "52px", marginBottom: "12px" }}>
              {Object.entries(demo.age).map(([key, count]) => {
                const pct = totalAge > 0 ? Math.round((count / totalAge) * 100) : 0;
                return (
                  <div key={key} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: "3px" }}>
                    <div style={{ width: "100%", height: `${Math.max(pct * 0.44, count > 0 ? 3 : 0)}px`, background: "#D41A6E", borderRadius: "3px 3px 0 0", opacity: 0.7 + (Object.keys(demo.age).indexOf(key) * 0.06) }} />
                    <span style={{ fontSize: "9px", color: "#64748b", fontWeight: 600 }}>{ageLabels[key]}</span>
                    {count > 0 && <span style={{ fontSize: "9px", color: "#94a3b8" }}>{pct}%</span>}
                  </div>
                );
              })}
            </div>
            <p style={{ fontSize: "10px", color: "#cbd5e1", textAlign: "center", margin: 0 }}>
              Données anonymisées — aucun client identifié
            </p>
          </>
        )}
      </div>
    </>
  );
}

  export default Dashboard;


